(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hr-product-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-hr-product-tab]');
  if (!button) return;
  const root = button.closest('[data-hr-product-details]');
  if (!root) return;
  const selected = button.getAttribute('data-hr-product-tab');
  root.querySelectorAll('[data-hr-product-tab]').forEach(function(tab) {
    const active = tab === button;
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.setAttribute('tabindex', active ? '0' : '-1');
  });
  root.querySelectorAll('[data-hr-product-panel]').forEach(function(panel) {
    panel.hidden = panel.getAttribute('data-hr-product-panel') !== selected;
  });
});

  } catch(e) { console.error(e); }
})();
})();
